module.exports = {
  Axis: require('./axis/'),
  Component: require('./base'),
  Guide: require('./guide/'),
  Label: require('./label/'),
  Legend: require('./legend/'),
  Tooltip: require('./tooltip/')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/lib/index.js
// module id = 24
// module chunks = 0 1 2